import { Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { Icon } from 'src/ui/shared/components/icon/Icon';
import { LocationInnerFormData } from '../location-form.models';

interface Props {
    id: string;
}

export const LocationButtons = ({ id }: Props): React.ReactElement => {
    const { unregister, watch } = useFormContext<LocationInnerFormData>();
    const value = watch();

    const disable = useMemo(() => {
        return Object.keys(value).length < 2;
    }, [value]);

    return (
        <Button
            variant={disable ? 'light' : 'outline-input'}
            disabled={disable}
            onClick={() => unregister(id)}
            className={`h-100 ${disable ? 'border' : ''}`}
            title="Remove"
        >
            <Icon icon="trash" iconClassName={disable ? 'text-muted' : 'text-dark'} />
        </Button>
    );
};
